import { TourConfig, startTour } from './TourSystem';
import 'driver.js/dist/driver.css';

// Helper to generate the description with the Take Tour button
const createTourStep = (title: string, description: string, url: string, tourTitle: string): any => {
    return {
        popover: {
            title,
            description: `
                ${description}
                <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
                     <button 
                        class="driver-deep-dive-btn"
                        data-deep-dive-url="${url}"
                        data-deep-dive-title="${tourTitle}"
                        style="
                            background: linear-gradient(135deg, #1a472a 0%, #2d6a4f 100%);
                            border: 1px solid #4ade80;
                            color: #d4af37;
                            font-weight: bold;
                            padding: 8px 16px;
                            border-radius: 6px;
                            cursor: pointer;
                            display: inline-flex;
                            align-items: center;
                            gap: 8px;
                            font-size: 0.85rem;
                            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);
                            transition: all 0.2s ease;
                        "
                        onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 6px 8px -1px rgba(0,0,0,0.6)'"
                        onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 6px -1px rgba(0,0,0,0.5)'"
                    >
                        <span>🚀</span> Take Tour
                    </button>
                </div>
            `,
            side: "top",
        },
        deepDive: { title: tourTitle, url }
    };
};

const landingTourConfig: TourConfig = {
    tourId: 'landing',
    steps: [
        {
            popover: {
                title: '🌍 Welcome to TechUnity Global',
                description: 'Your virtual headquarters for the future of work! Let\'s show you around quickly.',
            }
        },
        {
            element: '#landing-login-btn',
            popover: {
                title: '🔐 Member Login',
                description: 'Already part of the team? Click here to access your dashboard, projects, and wallet.',
                side: "bottom",
            }
        },
        {
            element: '#landing-signup-btn',
            popover: {
                title: '🚀 Join the Revolution',
                description: 'New here? Create your account in seconds! It\'s free and opens the door to global opportunities.',
                side: "bottom",
            }
        },
        {
            element: '#landing-hero-actions',
            popover: {
                title: '🧭 Start Exploring',
                description: 'Dive straight in! Go to your dashboard or explore open projects without waiting.',
                side: "top",
            }
        },
        {
            element: '#landing-nav-grid',
            popover: {
                title: '✨ Platform Features',
                description: 'Discover everything TechUnity offers. We will now guide you through each feature.',
                side: "top",
            }
        },
        {
            element: '#nav-card-dashboard',
            ...createTourStep('📊 Dashboard', 'Your command center. View activity overviews, quick stats, and recent updates at a glance.', '/dashboard', 'Dashboard')
        },
        {
            element: '#nav-card-projects',
            ...createTourStep('📁 Projects', 'Manage your ongoing work. Create new projects, track progress, and collaborate with your team here.', '/projects', 'Projects')
        },
        {
            element: '#nav-card-dispatch',
            ...createTourStep('⚡ TechUnity Dispatch', 'On-demand tasks matching your skills. Pick up gigs instantly and start earning.', '/dispatch', 'Dispatch')
        },
        {
            element: '#nav-card-skills',
            ...createTourStep('🌟 Skills Profile', 'Showcase your expertise. Keep your profile updated to get matched with the best opportunities.', '/skills', 'Skills')
        },
        {
            element: '#nav-card-workspace',
            ...createTourStep('💼 Workspace', 'Your digital office. Access real-time collaboration tools, whiteboards, and file sharing.', '/workspace', 'Workspace')
        },
        {
            element: '#nav-card-academy',
            ...createTourStep('🎓 Academy', 'Level up. Access premium courses, tutorials, and certifications to advance your career.', '/academy', 'Academy')
        },
        {
            element: '#nav-card-talent',
            ...createTourStep('🤝 Talent Network', 'Connect with global professionals. Build your network and find collaborators.', '/talent', 'Talent Network')
        },
        {
            element: '#nav-card-client',
            ...createTourStep('🏢 Client Portal', 'Manage client relationships, contracts, and deliverables securely.', '/client', 'Client Portal')
        },
        {
            element: '#nav-card-3dhub',
            ...createTourStep('🧊 3D Hub', 'Step into the future. Explore immersive 3D environments and virtual workspaces.', '/3dhub', '3D Hub')
        },
        {
            element: '#nav-card-aihub',
            ...createTourStep('🤖 AI Hub', 'Your intelligent assistant. Use AI to automate tasks, generate content, and solve problems.', '/unitybot', 'AI Hub')
        },
        {
            element: '#nav-card-financial',
            ...createTourStep('💰 My Vault', 'Your financial hub. Track earnings, manage withdrawals, and view transaction history securely.', '/financial', 'My Vault')
        }
    ],
};

export const startLandingTour = (initialStep?: number) => {
    startTour({ ...landingTourConfig, initialStep });
};
